import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { EditDetailDialog } from "../edit-detail-dialog/edit-detail-dialog.component";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { Program } from "../program-maintenance.component";

export class ProgramDetail {
    id: string;
    shortName: string;
    longName: string;
    hours: number;
    enableSurvey: boolean;
    surveyType: string;
    surveyGroup: string;
    surveyTrigger: string;
    surveyIdentifier: string;

    constructor(id, shortName, longName, hours, enableSurvey, surveyType, surveyGroup, surveyTrigger, surveyIdentifier) {
        this.id = id;
        this.shortName = shortName;
        this.longName = longName;
        this.hours = hours;
        this.enableSurvey = enableSurvey;
        this.surveyType = surveyType;
        this.surveyGroup = surveyGroup;
        this.surveyTrigger = surveyTrigger;
        this.surveyIdentifier = surveyIdentifier;
    }
}

@Component({
    selector: 'one-ring-program-detail-component',
    templateUrl: './program-detail.component.html',
    styleUrls: ['program-detail.component.scss']
})
export class ProgramDetailComponent implements OnInit {
    @Input() programDetails;

    @Output() detailUpdateComplete = new EventEmitter<boolean>();

    mappedDetails: MatTableDataSource<ProgramDetail>;
    displayedColumns = [
        'edit',
        'shortName',
        'longName',
        'hours',
        'enableSurvey',
        'surveyType',
        'surveyGroup',
        'surveyTrigger',
        'surveyIdentifier'
    ];

    constructor(private dialog: MatDialog) {}

    ngOnInit(): void {
        const localProgramDetails = [];
        this.programDetails.forEach(detail => {
            const newProgramDetail = this.mapDetail(detail);
            localProgramDetails.push(newProgramDetail);
        });
        this.mappedDetails = new MatTableDataSource<ProgramDetail>(localProgramDetails);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const programDetailsChange = changes['programDetails'];

        if (programDetailsChange) {
            const localDetails = [];
            const newValue = programDetailsChange.currentValue;
            newValue.forEach((value) => {
                const newDetail = this.mapDetail(value);
                localDetails.push(newDetail);
            });
            this.mappedDetails = new MatTableDataSource<ProgramDetail>(localDetails);
        }
    }

    mapDetail(programDetail): ProgramDetail {
        return new ProgramDetail(
            programDetail.PROGRAMDETAIL_ID,
            programDetail.SHORTNAME,
            programDetail.LONGNAME,
            programDetail.HOURS,
            programDetail.SURVEYACTIVE,
            programDetail.SURVEYWORKORDERTYPE,
            programDetail.SURVEYGROUP,
            programDetail.SURVEYTRIGGER,
            programDetail.SURVEYIDENTIFIER
        );
    }

    openDetailDialog(detail: ProgramDetail): void {
        const dialogRef = this.dialog.open(EditDetailDialog, {
            width: '60%',
            height: '60%',
            data: detail
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result != null && result['isChangeComplete']) {
                this.detailUpdateComplete.emit(true);
            }
        });
    }
}